import { j as n } from "../../jsx-runtime-Wav_3Wde.js";
import { s as m } from "../../index.esm-DOxVcNnO.js";
import { forwardRef as c } from "react";
import { styled as e, css as l } from "styled-components";
import { compose as p, typography as f, space as k } from "styled-system";
import "../../Icon/StyledPath.mjs";
import w from "../../Icon/Icons/NewTabIcon.mjs";
import x from "../VisuallyHidden/VisuallyHidden.mjs";
const u = /* @__PURE__ */ e.a.withConfig({
  shouldForwardProp: (o) => m(o) && ![
    "size",
    "variant"
  ].includes(o)
}).withConfig({
  componentId: "sc-a61bfa63-0"
})([
  "",
  " ",
  ""
], ({ theme: o, size: i, variant: a }) => /* @__PURE__ */ l([
  "",
  " ",
  " ",
  ""
], o.components.link.base, o.components.link[a], o.components.link[i]), p(f, k)), b = /* @__PURE__ */ e(w).withConfig({
  componentId: "sc-a61bfa63-1"
})([
  "",
  ""
], ({ theme: o }) => o.components.link.newTabIcon), g = (o) => o ? {
  rel: "noopener noreferrer",
  target: "_blank"
} : {}, j = /* @__PURE__ */ c(({ size: o = "medium", variant: i = "dark", external: a = !1, children: r, ...s }, d) => {
  const t = s["data-qa-id"] || `${a ? "external-link" : "link"}`;
  return /* @__PURE__ */ n.jsx(u, {
    size: o,
    variant: i,
    ref: d,
    ...g(a),
    ...s,
    "data-qa-id": t,
    children: a ? /* @__PURE__ */ n.jsxs(n.Fragment, {
      children: [
        /* @__PURE__ */ n.jsx("span", {
          "data-qa-id": `${t}-text`,
          children: r
        }),
        /* @__PURE__ */ n.jsx(x, {
          children: "opens in a new tab"
        }),
        /* @__PURE__ */ n.jsx(b, {
          "data-qa-id": `${t}-icon`,
          size: o === "small" ? 20 : 24
        })
      ]
    }) : r
  });
});
j.displayName = "Link";
export {
  u as StyledLink,
  j as default
};
